import { Cog6ToothIcon, PencilSquareIcon, BuildingStorefrontIcon, ChartPieIcon, ClipboardDocumentIcon } from '@heroicons/react/24/outline'
import Footer from './Footer';
import Topbar from './Topbar';

const features = [
  {
    name: 'Fractional Leadership',
    description:
      'We realize that costs can be prohibitive for the level of services some organziations need.  We offer fractional leadership to help you get what you need at a price you can afford.  We can pair some of our best people with your organziation to set the tone, establish vision, and put together a plan to help you remain competitive in today\'s market.',
    icon: ChartPieIcon,
  },
  {
    name: 'Coaching and Mentoring',
    description:
      'When you are in the game it\'s hard to see the whole field. We partner with you for those tough decisions so you can confidently make the right moves.  We believe you often get one shot and we want it to be on target.',
    icon: ClipboardDocumentIcon,
  },
  {
    name: 'Assessment and Feedback',
    description:
      'Timely assessment and feedback are critical.  Tight feedback loops can mean the difference between making a deadline or blowing it.  Let our community of experts help you and your team with a top down assessment of your processes and procedures.',
    icon: PencilSquareIcon,
  },
  {
    name: 'Architecture and Modeling',
    description:
      'At the outset of a project the stakes are high.  We can help you with architecture and modeling to ensure that you reduce risks and leave no stone unturned.  We believe that the best projects start with a solid foundation.',
    icon: BuildingStorefrontIcon,
  },
  {
    name: 'Design and Development',
    description:
      'We offer full service design and development services.  We can help you with your next project from concept to launch.  If you are looking for a partner we are here to help.',
    icon: Cog6ToothIcon,
  },
]

export default function Services() {
  return (
    <div>
        <Topbar />
        <div className="bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-8 sm:gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            <h2 className="text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
                Some of the services that we offer
            </h2>
            <dl className="col-span-2 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2">
                {features.map((feature) => (
                <div key={feature.name}>
                    <dt className="text-base font-semibold leading-7 text-gray-900">
                    <div className="mb-6 flex h-10 w-10 items-center justify-center rounded-lg bg-gray-600">
                        <feature.icon aria-hidden="true" className="h-6 w-6 text-white" />
                    </div>
                    {feature.name}
                    </dt>
                    <dd className="mt-1 text-base leading-7 text-gray-600">{feature.description}</dd>
                </div>
                ))}
            </dl>

            </div>
        </div>


        <div className="mx-auto max-w-7xl px-8 py-8 sm:py-8 lg:flex lg:items-center lg:justify-between lg:px-8">
            <h1 className="text-2xl tracking-tight text-gray-900 sm:text-3xl">
            We are excited to partner with you. 
            <br />
            </h1>
            <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
            <a
                href="/servicerequest"
                className="rounded-md bg-gray-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
                Get started
            </a>
            <a href="/contact" className="text-sm font-semibold leading-6 text-gray-900 hover:text-gray-400">
                Let's talk! <span aria-hidden="true">→</span>
            </a>
            </div>
        </div>
        </div>

        <Footer />
    </div>

  )
}
